export default {
  dataSearchList: [],
  dataSearchReq: [],
  searchData: {},
  listPaging: {
    limit: 10,
    offset: 0,
    sort: '',
  },
  reqPaging: {
    limit: 10,
    offset: 0,
    field: '',
    sort: '',
  },
};
